"use strict";
Object.defineProperty(exports, "__esModule", { value: true });



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/store/status-value.ts
// module id = 3276
// module chunks = 0